"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentimentSurveyLanding = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * PromoteUnauthUser
 */
var react_1 = __importDefault(require("react"));
var react_redux_firebase_1 = require("react-redux-firebase");
var Main_1 = __importDefault(require("components/Layout/Main"));
var LoadingSingle_1 = __importDefault(require("components/LoadingSpinner/LoadingSingle"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var AuthIntroSection_1 = __importDefault(require("containers/Authentication/AuthIntroSection"));
var LayoutCenter_1 = __importDefault(require("containers/Authentication/styles/LayoutCenter"));
var StyledGrid_1 = __importDefault(require("containers/Authentication/styles/StyledGrid"));
var backend_1 = require("utils/backend");
var HoCs_1 = require("utils/HoCs");
var logging_1 = require("utils/logging");
var LoginForm_1 = __importDefault(require("./LoginForm"));
function SentimentSurveyLanding(_a) {
    var _this = this;
    var authState = _a.authState, profile = _a.profile, history = _a.history, invId = _a.match.params.invId;
    var firebase = (0, react_redux_firebase_1.useFirebase)();
    var _b = __read(react_1.default.useState(false), 2), loading = _b[0], setLoading = _b[1];
    var _c = __read(react_1.default.useState(''), 2), needsLogIn = _c[0], setNeedsLogIn = _c[1];
    var redirectPath = react_1.default.useRef('');
    var _d = __read(react_1.default.useState(null), 2), fixedEmail = _d[0], setFixedEmail = _d[1];
    var invRef = firebase.firestore().collection('invitations').doc(invId);
    var qParamsRedirect = new URLSearchParams(window.location.search).get('redirectTo');
    react_1.default.useEffect(function () {
        var activateUnauthSurveyInvite = (0, backend_1.callBackendFn)('invitations-activateUnauthSurveyInvite');
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var invitation, _a, email, password, redirectTo, auth;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!(0, react_redux_firebase_1.isLoaded)(authState)) {
                            return [2 /*return*/];
                        }
                        if (!!(0, react_redux_firebase_1.isEmpty)(authState)) return [3 /*break*/, 3];
                        if (!((0, react_redux_firebase_1.isLoaded)(profile) && !(0, react_redux_firebase_1.isEmpty)(profile) && !profile.isUnauthUser)) return [3 /*break*/, 2];
                        return [4 /*yield*/, invRef.get()];
                    case 1:
                        invitation = _d.sent();
                        // if (invitation.get('usedBy') === authState.uid && invitation.get('promoted')) {
                        if (invitation.get('usedBy') === authState.uid && invitation.get('promoted')) {
                            history.push(invitation.get('redirectTo'));
                        }
                        _d.label = 2;
                    case 2: return [2 /*return*/];
                    case 3: return [4 /*yield*/, activateUnauthSurveyInvite({ invId: invId })];
                    case 4:
                        _a = (_d.sent()).data, email = _a.email, password = _a.password, redirectTo = _a.redirectTo;
                        redirectPath.current = qParamsRedirect || redirectTo;
                        if (!password) return [3 /*break*/, 6];
                        return [4 /*yield*/, firebase.auth().signInWithEmailAndPassword(email, password)
                                .catch(function (_a) {
                                var code = _a.code;
                                (0, logging_1.logError)('code', code);
                                if (code === 'auth/wrong-password') {
                                    setNeedsLogIn('password');
                                }
                            })];
                    case 5:
                        auth = _d.sent();
                        if ((_c = (_b = auth === null || auth === void 0 ? void 0 : auth.user) === null || _b === void 0 ? void 0 : _b.providerData) === null || _c === void 0 ? void 0 : _c.some(function (usrInf) { return (usrInf === null || usrInf === void 0 ? void 0 : usrInf.providerId) === 'google.com'; })) {
                            history.push(redirectPath.current);
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        setNeedsLogIn('password');
                        _d.label = 7;
                    case 7:
                        setFixedEmail(email);
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [(0, react_redux_firebase_1.isLoaded)(authState), (0, react_redux_firebase_1.isLoaded)(profile)]);
    if (!authState || !(0, react_redux_firebase_1.isLoaded)(authState) || !profile || !(0, react_redux_firebase_1.isLoaded)(profile) || !redirectPath) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    var email = (profile === null || profile === void 0 ? void 0 : profile.email) || fixedEmail;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Hudled Promote User", description: "Hudled Promote User" }), (0, jsx_runtime_1.jsx)(Main_1.default, { children: (0, jsx_runtime_1.jsx)(LayoutCenter_1.default, { children: (0, jsx_runtime_1.jsxs)(StyledGrid_1.default, __assign({ container: true, spacing: 2, justifyContent: "center" }, { children: [(0, jsx_runtime_1.jsx)(AuthIntroSection_1.default, { welcomeMsg: needsLogIn !== 'password'
                                    ? 'Choose how you want to sign up'
                                    : 'Please log in with the password you\'ve set up' }), loading || !email
                                ? (0, jsx_runtime_1.jsx)(LoadingSingle_1.default, {})
                                : ((0, jsx_runtime_1.jsx)(LoginForm_1.default, { loading: loading, setLoading: setLoading, needsLogin: needsLogIn, fixedEmail: email, redirectPath: redirectPath.current, invId: invId }))] })) }) })] }));
}
exports.SentimentSurveyLanding = SentimentSurveyLanding;
exports.default = react_1.default.memo((0, HoCs_1.AuthHoC)(SentimentSurveyLanding));
